import {deepAssign} from './deep-assign.js';

/**
 * Debounces a function while combining the passed data.
 *
 * @example

  const db = new DebounceCombiner({
    callback: data => fetch(url, data),
    debounceDuration: 1000
  });
  db.push({ name: 'John' });
  db.push({ age: 30 })
  db.push({ name: 'John Doe' });
  // after 1s ==> fetch(url, { name: 'John Doe', age: 30 });

  */
class DebounceCombiner {
  /**
   * @param {Object} options -
   * @param {Function} options.callback - (url, data)
   * @param {Number} [options.debounceDuration] - in ms
   */
  constructor(options) {
    const defaults = {
      callback: data => {
        throw Error('No callback defined')
      },
      debounceDuration: 2500,
      debounceTimeout: false
    };
    this.combinedData = {};
    Object.assign(this, defaults, options);
  }

  /**
   * Resets the timeout and combines given data with any
   * previous unprocessed
   * @param {Object} data - The new data to use
   */
  push(data) {
    if(this.debounceTimeout) {
      this.debounceTimeout = clearTimeout(this.debounceTimeout);
    }
    this.combinedData = deepAssign({}, this.combinedData, data);
    this.debounceTimeout = setTimeout(
      () => {
        this.callback(this.combinedData);
        this.combinedData = {};
      },
      this.debounceDuration
    );
  }
}

export { DebounceCombiner };
export default DebounceCombiner;
